import React, { PropsWithChildren } from 'react'

import { Pill } from 'component-library-next'

import './CheckResultsLayout.scss'

export const CheckResultsLayout = ({ children }: PropsWithChildren<any>) => {
  return <div className='ai-result__result-category'>{children}</div>
}

CheckResultsLayout.Title = ({ children }: PropsWithChildren<any>) => {
  return <Pill color={Pill.colors.warning}>{children}</Pill>
}

CheckResultsLayout.Description = ({ children }: PropsWithChildren<any>) => {
  return <div className='ai-result__text ai-result__text--description'>{children}</div>
}
